var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pane-content"},[_c('h3',{staticClass:"medium-blue"},[_vm._v(_vm._s(_vm.$t('subasta.notificacion.titulo')))]),_c('NotificationsLayout',{on:{"formValid":function($event){_vm.continuar = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }